import { CONTENT_TYPE } from '@/entities/public-filter/constants';
import { type SavedQueryOptions } from '@/entities/query/types';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/shared/components/shadcn/select';

export const FilterCondition = ({
  options,
  onChange,
}: {
  options: SavedQueryOptions;
  onChange: (options: SavedQueryOptions) => void;
}) => {
  return (
    <div className="flex flex-col gap-6 rounded-lg border p-6">
      <label className="text-base font-medium">Filter condition</label>
      <div className="flex justify-between">
        <label htmlFor="filter-condition">Sponsored post</label>
        <Select
          value={options.sponsored_post.toString()}
          onValueChange={(value) => onChange({ ...options, sponsored_post: parseInt(value) })}
        >
          <SelectTrigger>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value={CONTENT_TYPE.ALL.toString()}>All posts</SelectItem>
            <SelectItem value={CONTENT_TYPE.ORGANIC.toString()}>Organic posts only</SelectItem>
            <SelectItem value={CONTENT_TYPE.SPONSORED.toString()}>Sponsored posts only</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};
